import { IBaseQueryParameters } from '../index.js'

/**
 * This interface defines the path parameters for the endpoints available in the
 * `Congress` endpoint class.
 */
export interface ICongressPathParameters extends IBaseQueryParameters {
  /**
   * The congress number. For example, the value can be `117` for the 117th
   * Congress.
   */
  congress?: number
}
